import React, { useState } from 'react';

const zoomOptions = [25, 50, 75, 100, 125, 150, 200];

const EditorTopBar = ({
  projectName,
  draftName,
  isEditingName,
  onStartEditingName,
  onNameChange,
  onCommitName,
  onCancelName,
  saveStatus,
  zoom,
  onZoomChange,
  onZoomIn,
  onZoomOut,
  onFit,
  onResize,
  showGuides,
  onToggleGuides,
  onBack,
  onExport,
}) => {
  const zoomPercent = Math.round(zoom * 100);
  const zoomLabel = `${zoomPercent}%`;
  const selectValue = zoomPercent;
  const showCustomOption = !zoomOptions.includes(selectValue);
  const [showZoomTip, setShowZoomTip] = useState(false);

  return (
    <div className="studio-editor-topbar">
      <div className="studio-editor-topbar-left">
        {onBack && (
          <button type="button" className="studio-topbar-btn studio-back-btn" onClick={onBack}>
            Back to Studio Home
          </button>
        )}
        <div className="studio-editor-brand">
          <span className="studio-editor-brand-mark">S</span>
          <span>Studio</span>
        </div>
      </div>

      <div className="studio-editor-topbar-center">
        {isEditingName ? (
          <input
            className="studio-editor-name-input"
            value={draftName ?? projectName}
            onChange={(event) => onNameChange(event.target.value)}
            onBlur={onCommitName}
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                event.preventDefault();
                onCommitName();
              }
              if (event.key === 'Escape') {
                event.preventDefault();
                onCancelName();
              }
            }}
            autoFocus
          />
        ) : (
          <button
            type="button"
            className="studio-editor-name"
            onClick={onStartEditingName}
            title="Rename project"
          >
            {projectName}
          </button>
        )}
      </div>

      <div className="studio-editor-topbar-right">
        <div className="studio-editor-save-status">{saveStatus}</div>
        <button type="button" className="studio-topbar-btn" disabled>
          Undo
        </button>
        <button type="button" className="studio-topbar-btn" disabled>
          Redo
        </button>
        <div className="studio-zoom-controls">
          {showZoomTip && <div className="studio-zoom-tooltip">{zoomLabel}</div>}
          <button
            type="button"
            className="studio-topbar-btn"
            onClick={onZoomOut}
            aria-label="Zoom out"
          >
            -
          </button>
          <select
            className="studio-zoom-select"
            value={selectValue}
            onChange={(event) => onZoomChange(Number(event.target.value))}
            aria-label="Zoom percentage"
          >
            {showCustomOption && (
              <option value={selectValue}>{selectValue}%</option>
            )}
            {zoomOptions.map((option) => (
              <option key={option} value={option}>
                {option}%
              </option>
            ))}
          </select>
          <input
            type="range"
            className="studio-zoom-slider"
            min={10}
            max={400}
            step={1}
            value={zoomPercent}
            onChange={(event) => onZoomChange(Number(event.target.value))}
            onMouseDown={() => setShowZoomTip(true)}
            onMouseUp={() => setShowZoomTip(false)}
            onTouchStart={() => setShowZoomTip(true)}
            onTouchEnd={() => setShowZoomTip(false)}
            onBlur={() => setShowZoomTip(false)}
            aria-label="Zoom slider"
          />
          <button
            type="button"
            className="studio-topbar-btn"
            onClick={onZoomIn}
            aria-label="Zoom in"
          >
            +
          </button>
          <button type="button" className="studio-topbar-btn" onClick={onFit}>
            Fit
          </button>
          <button type="button" className="studio-topbar-btn" onClick={onResize}>
            Resize
          </button>
        </div>
        <button
          type="button"
          className={`studio-topbar-btn ${showGuides ? 'active' : ''}`}
          onClick={onToggleGuides}
        >
          Guides
        </button>
        <button
          type="button"
          className="studio-topbar-btn"
          onClick={onExport}
          disabled={!onExport}
        >
          Export
        </button>
        <div className="studio-zoom-label">{zoomLabel}</div>
      </div>
    </div>
  );
};

export default EditorTopBar;
